import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as MisthoseisActions from '../actions/misthoseis.actions';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MisthoseisModel } from 'src/app/core/models/misthoseis.model';

@Injectable()
export class MisthoseisEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  getMisthoseisByRightId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MisthoseisActions.getMisthoseisByRightId),
      mergeMap(({ rightId }) =>
        this.http.get<MisthoseisModel[]>(`${environment.apiUrl}/getmisthoseis/${rightId}`).pipe(
          map(misthoseis =>
            MisthoseisActions.getMisthoseisSuccess({ rightId, misthoseis })
          ),
          catchError(error =>
            of(MisthoseisActions.getMisthoseisFail({ error }))
          )
        )
      )
    )
  );

  deleteMisthosi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MisthoseisActions.deleteMisthosi),
      mergeMap(({ id, rightId }) =>
        this.http.delete(`${environment.apiUrl}/misthoseis/${id}`).pipe(
          map(() => MisthoseisActions.deleteMisthosiSuccess({ id, rightId })),
          catchError(error =>
            of(MisthoseisActions.deleteMisthosiFail({ error }))
          )
        )
      )
    )
  );
}
